import type { ISellAssets } from 'BreetHelpers';

export const filterBySymbol = (symbol?: string) => (tradeSellAssetItem: ISellAssets) =>
	tradeSellAssetItem.symbol === symbol && tradeSellAssetItem.wallet?.isVip;

export const filterBySearch = (searchValue: string) => (tradeSellAssetItem: ISellAssets) =>
	tradeSellAssetItem.name.toLowerCase().includes(searchValue.toLowerCase()) ||
	tradeSellAssetItem.symbol.toLowerCase().includes(searchValue.toLowerCase());
